<script>
export default {

}
</script>

<template>
    <ul class="about-footer-menu">
        <a
            href="https://frisky.fm/about/privacy-policy"
            class="footer-link"
            target="_blank"
        >
            Privacy Policy
        </a>
        <a
            href="https://frisky.fm/about/terms"
            class="footer-link"
            target="_blank"
        >
            Terms of Use
        </a>
    </ul>
</template>

<style lang="scss" scoped>
@import '@design';

.about-footer-menu {
    display: flex;
    gap: $s-m;
    padding: 0;
    margin: 0;
}

.footer-link {
    font-size: 12px;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
}
</style>
